import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import UserProfileModal from "./UserProfileModal";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import "./Header.css";

function Header({ title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const { t } = useTranslation();

  const displayName =
    [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() ||
    user?.email ||
    "User";
  const initial = (user?.first_name?.charAt(0) || user?.email?.charAt(0) || "U").toUpperCase();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">{title}</h1>

        <div className="header-actions">
          <button
            type="button"
            className="user-info user-info-clickable"
            onClick={() => setProfileModalOpen(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setProfileModalOpen(true);
              }
            }}
            aria-label={t("header.profile.ariaLabel")}
            tabIndex={0}
          >
            <div className="user-avatar" aria-hidden="true">{initial}</div>
            <div className="user-details">
              <span className="user-name">{displayName}</span>
              <span className="user-role">{user?.role || ""}</span>
            </div>
          </button>
          <LanguageSwitcher />
          <button className="btn-logout" onClick={handleLogout}>
            {t("common.logout")}
          </button>
        </div>
      </div>
      <UserProfileModal
        user={user}
        isOpen={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      />
    </header>
  );
}

export default Header;
